import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pending'
})
export class PendingPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
